import { render, staticRenderFns } from "./DetalleAgendamiento.vue?vue&type=template&id=ef6fccda&scoped=true&"
import script from "./DetalleAgendamiento.vue?vue&type=script&lang=js&"
export * from "./DetalleAgendamiento.vue?vue&type=script&lang=js&"
import style0 from "./DetalleAgendamiento.vue?vue&type=style&index=0&id=ef6fccda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6fccda",
  null
  
)

export default component.exports